import {useAppContext} from "../../../context/AppContext";
import ResultText from "../ResultText";

export default function StructureAssociateFootnote() {
    const {getSelectedHistory} = useAppContext()

    return (
        <div>
            {
                getSelectedHistory()?.associate?.structure?.map(c => (
                    <div key={c?.cross_section}>
                        <ResultText>
                            The {c?.type} at RS {c?.cross_section} is replaced with {c?.type} at RS {c?.assoc_cross_section} at {c?.assoc_diff} ft {c?.direction} of the original location.  They are associated for comparison purposes.
                        </ResultText>
                    </div>
                ))
            }
        </div>
    )
}